/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  SubscriptionUserControllerFindPlansQueryResponse,
  SubscriptionUserControllerFindPlans401,
} from '../types/SubscriptionUserControllerFindPlans.ts';

function getSubscriptionUserFindPlansUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/subscriptions/plans` as const };
  return res;
}

/**
 * {@link /api/user/telegram/subscriptions/plans}
 */
export async function subscriptionUserFindPlans(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    SubscriptionUserControllerFindPlansQueryResponse,
    ResponseErrorConfig<SubscriptionUserControllerFindPlans401>,
    unknown
  >({ method: 'GET', url: getSubscriptionUserFindPlansUrl().url.toString(), ...requestConfig });
  return res.data;
}
